import React, { useState } from "react";

export default function LegalPage() {
  const [activeTab, setActiveTab] = useState("privacy");

  return (
    <div className="legal-container">
        <p style={{fontSize:50,color:'black', fontWeight:'bolder', textAlign:'center', marginBottom:30,marginTop:50}}>LEGAL</p>
      {/* Tabs Navigation */}
      <div className="tab-buttons">
        <button
          className={activeTab === "privacy" ? "active" : ""}
          onClick={() => setActiveTab("privacy")}
        >
          Privacy Policy
        </button>
        <button
          className={activeTab === "terms" ? "active" : ""}
          onClick={() => setActiveTab("terms")}
        >
          Terms & Conditions
        </button>
        <button
          className={activeTab === "cookies" ? "active" : ""}
          onClick={() => setActiveTab("cookies")}
        >
          Cookie Policy
        </button>
      </div>

      {/* Tabs Content */}
      <div className="tab-content">
        {activeTab === "privacy" && (
          <div style={{  margin: "auto", padding: "20px" }}>
            <h1>Privacy Policy</h1>
            <p><strong>Last Updated:</strong> 29 October 2024</p>
        
            <h2>Introduction</h2>
            <p>
                Welcome to SR HR's Privacy Policy. This Privacy Policy explains how SR HR ("we", "us", "our") collects, 
                uses, discloses, and safeguards your information when you use our website at srhr.io (the "Site") 
                and our human resources management services (collectively, the "Service").
            </p>
            <p>
                Please read this Privacy Policy carefully. By accessing or using our Service, you acknowledge that 
                you have read, understood, and agree to be bound by all the terms outlined in this Privacy Policy. 
                If you do not agree with our policies and practices, please do not use our Service.
            </p>
        
            <h2>Information We Collect</h2>
        
            <h3>Personal Information</h3>
            <p>We collect several types of information from and about users of our Service, including:</p>
            <ul>
                <li>Contact information (such as name, email address, mailing address, phone number)</li>
                <li>Professional information (such as job title, department, and office location)</li>
                <li>Account login credentials</li>
                <li>Company information</li>
                <li>Employee data that you input into the Service</li>
                <li>Payment information</li>
                <li>Usage data and analytics</li>
                <li>Communication preferences</li>
            </ul>
        
            <h3>Usage Information</h3>
            <p>We automatically collect certain information about your device when you use our Service, including:</p>
            <ul>
                <li>IP addresses</li>
                <li>Browser type and version</li>
                <li>Device type and identifiers</li>
                <li>Operating system</li>
                <li>Time zone setting and location</li>
                <li>Pages viewed and features used</li>
                <li>Access times and dates</li>
                <li>Clickstream data</li>
                <li>Other usage statistics</li>
            </ul>
        
            <h2>How We Use Your Information</h2>
            <p>We use the information we collect to:</p>
            <ul>
                <li>Provide, maintain, and improve our Service</li>
                <li>Process your transactions and send related information</li>
                <li>Respond to your comments, questions, and requests</li>
                <li>Send you technical notices, updates, security alerts, and support messages</li>
                <li>Detect, prevent, and address technical issues</li>
                <li>Monitor and analyze trends, usage, and activities</li>
                <li>Develop new products, services, features, and functionality</li>
                <li>Personalize and improve your experience</li>
                <li>Comply with legal obligations</li>
                <li>Protect against, investigate, and deter fraudulent, unauthorized, or illegal activity</li>
            </ul>
        
            <h2>Information Sharing and Disclosure</h2>
            <p>We may share your information in the following situations:</p>
            <ul>
                <li>With your consent</li>
                <li>With our service providers and partners who assist in operating our Service</li>
                <li>To comply with legal obligations</li>
                <li>To protect and defend our rights and property</li>
                <li>In connection with a business transfer or corporate restructuring</li>
                <li>With our affiliates and subsidiaries</li>
                <li>When the information is aggregated or anonymized</li>
            </ul>
        
            <h2>Data Retention and Security</h2>
            <p>
                We retain your information for as long as necessary to fulfill the purposes outlined in this Privacy 
                Policy, unless a longer retention period is required or permitted by law. We implement appropriate 
                technical and organizational security measures to protect your information from unauthorized access, 
                disclosure, alteration, and destruction.
            </p>
        
            <h2>Your Rights and Choices</h2>
            <p>Depending on your location, you may have certain rights regarding your personal information, including:</p>
            <ul>
                <li>Access to your personal information</li>
                <li>Correction of inaccurate or incomplete information</li>
                <li>Deletion of your personal information</li>
                <li>Data portability</li>
                <li>Withdrawal of consent</li>
                <li>Objection to processing</li>
            </ul>
            <p>To exercise these rights, please contact us at support@srhr.io.</p>
        
            <h2>International Data Transfers</h2>
            <p>
                Your information may be transferred to and processed in countries other than your country of residence. 
                These countries may have different data protection laws. When we transfer your information, we will 
                protect it as described in this Privacy Policy and comply with applicable legal requirements.
            </p>
        
            <h2>Children's Privacy</h2>
            <p>
                Our Service is not intended for children under 13 years of age. We do not knowingly collect personal 
                information from children under 13. If you are under 13, please do not use our Service or provide 
                any information to us.
            </p>
        
            <h2>Changes to This Privacy Policy</h2>
            <p>
                We may update this Privacy Policy from time to time. The updated version will be indicated by an updated 
                "Last Updated" date. Your continued use of our Service after any changes indicates your acceptance of 
                the updated Privacy Policy.
            </p>
        
            <h2>Third-Party Services</h2>
            <p>
                Our Service may contain links to third-party websites or services. We are not responsible for the privacy 
                practices or content of these third-party services. We encourage you to review the privacy policies of 
                any third-party services you access.
            </p>
        
            <h2>Governing Law</h2>
            <p>
                This Privacy Policy is governed by and construed in accordance with the laws of Singapore. Any disputes 
                relating to this Privacy Policy shall be subject to the exclusive jurisdiction of the courts of Singapore.
            </p>
        
            <h2>Contact Us</h2>
            <p>
                If you have questions, concerns, or requests related to this Privacy Policy or our privacy practices, 
                please contact us at:
            </p>
            <p><strong>Email:</strong> <a href="mailto:info@kelick.io">info@kelick.io</a></p>
            </div>
        )}

        {activeTab === "terms" && (
         <div style={{  margin: "auto", padding: "20px" }}>
         <h1>Terms of Service</h1>
         <p>Our Terms of Service were last updated on 29 October 2024.</p>
         <p>Please read these terms and conditions carefully before using Our Service.</p>
   
         <p>
           These terms of service ("Terms") constitute a contract between you and SR HR
           ("SR HR", "we", "us" and/or "our") and govern the use by you, your admins and
           employees of our website and all of the products and Services (as defined below)
           offered by SR HR.
         </p>
   
         <p>
           By accepting these Terms, or by accessing or using the Service or Site, or
           authorizing or permitting any admin or end-user to access or use the Service or
           Site, you agree to be bound by these Terms. If you are entering into these Terms
           on behalf of a company, organization or another legal entity (an "entity"), you
           are agreeing to these Terms for and on behalf of that entity and representing to
           SR HR that you have the authority to bind such entity and its affiliates to these
           Terms, in which case the terms "you," "your" or related capitalized terms herein
           shall refer to such entity and its affiliates. If you do not have such authority,
           or if you do not agree with these Terms, you must not accept these Terms and may
           not use the Service, or continue accessing the Site.
         </p>
   
         <p>If you have any questions about these terms, please feel free to contact us at support@srhr.io.</p>
   
         <h2>1. Service</h2>
         <h3>1.1. Description</h3>
         <p>
           SR HR provides hosted integrated cloud human resources solutions through the Site
           and any applicable software (as defined below) (collectively, the "Service"). The
           Service is provided by SR HR to you and any individual or entity to whom you grant
           the right to access the Service through your account as an administrator and/or
           agent as identified through a unique login ("admin"), or as an end-user
           connecting with you or your admins via the service ("employees"), subject to
           these Terms and all modifications thereto and/or other rules that may be
           published from time to time by SR HR.
         </p>
   
         <h3>1.2. Subscription</h3>
         <p>
           During the term of your subscription to the Service ("Subscription"), you have
           the limited right to use the Service solely for your own internal, personal or
           limited commercial use as an online platform to communicate with your employees.
           The terms of your Subscription, including without limitation, the fees for the
           Service, the Subscription Period and the number of admins or employees permitted,
           shall be set out in the relevant "Subscription Plans" provided by SR HR.
         </p>
   
         <h2>2. Data Processing and Protection</h2>
         <h3>2.1. Data Processing Activities</h3>
         <ul>
           <li>We process your data only for the purposes specified in these Terms and as necessary to provide the Service.</li>
           <li>We maintain appropriate technical and organizational measures to protect your data.</li>
           <li>We only retain your data for as long as necessary to provide the Service and comply with legal obligations.</li>
           <li>We do not sell, rent, or share your data with third parties except as necessary to provide the Service.</li>
         </ul>
   
         <h3>2.2. Security Measures</h3>
         <ul>
           <li>All data is encrypted in transit and at rest using industry-standard encryption.</li>
           <li>We maintain regular security assessments and penetration testing.</li>
           <li>Access to your data is strictly limited to authorized personnel.</li>
           <li>We maintain incident response and disaster recovery procedures.</li>
         </ul>
   
         <h3>2.3. Your Data Responsibilities</h3>
         <ul>
           <li>You retain ownership of all data you input into the Service.</li>
           <li>You are responsible for the accuracy and legality of your data.</li>
           <li>You must maintain appropriate security for your account credentials.</li>
           <li>You must notify us immediately of any unauthorized access.</li>
         </ul>
   
         <h2>3. Service Level Commitments</h2>
         <h3>3.1. Availability</h3>
         <ul>
           <li>We target 99.9% uptime, excluding scheduled maintenance.</li>
           <li>Scheduled maintenance will be communicated at least 48 hours in advance.</li>
           <li>Emergency maintenance may be performed as needed to maintain security and stability.</li>
         </ul>
   
         <h3>3.2. Support Response Times</h3>
         <ul>
           <li>Critical issues: Within 2 hours during business hours.</li>
           <li>High priority issues: Within 4 business hours.</li>
           <li>Normal priority issues: Within 1 business day.</li>
           <li>Low priority issues: Within 2 business days.</li>
         </ul>
   
         <h2>4. Acceptable Use</h2>
         <h3>4.1. Prohibited Activities</h3>
         <ul>
           <li>Attempts to gain unauthorized access to the Service.</li>
           <li>Transmission of malicious software or harmful code.</li>
           <li>Harassment or abuse of other users.</li>
           <li>Violation of any applicable laws or regulations.</li>
           <li>Interference with other users' use of the Service.</li>
           <li>Reverse engineering or decompiling the Service.</li>
           <li>Unauthorized scraping or data collection.</li>
         </ul>
   
         <h3>4.2. Content Guidelines</h3>
         <ul>
           <li>All content must be legal and appropriate.</li>
           <li>No discriminatory or offensive content.</li>
           <li>No confidential information of third parties.</li>
           <li>No intellectual property infringement.</li>
           <li>No misleading or fraudulent content.</li>
         </ul>
   
         <h2>5. Security Requirements</h2>
         <h3>5.1. Account Security</h3>
         <ul>
           <li>Passwords must meet minimum complexity requirements.</li>
           <li>Two-factor authentication is required for administrative access.</li>
           <li>Regular security audits of user access.</li>
           <li>Prompt reporting of security incidents.</li>
         </ul>
   
         <h3>5.2. User Obligations</h3>
         <ul>
           <li>Maintain confidentiality of credentials.</li>
           <li>Regular password updates.</li>
           <li>No sharing of user accounts.</li>
           <li>Compliance with security policies.</li>
         </ul>
   
         <h2>6. Intellectual Property Rights</h2>
         <h3>6.1. Ownership</h3>
         <p>SR HR owns all rights to the Service and software. You retain all rights to your data.</p>
   
         <p>
           Contact us at <a href="mailto:info@kelick.io">info@kelick.io</a> for any questions about these Terms.
         </p>
       </div>
        )}

        {activeTab === "cookies" && (
          <div style={{  margin: "auto", padding: "20px" }}>
          <h1>Cookie Policy</h1>
          <p>
            This cookie policy applies to all SR HR websites, platforms, and mobile applications 
            (collectively referred to as "SR HR Platforms"). You may access and manage your cookie 
            preferences through your browser settings at any time.
          </p>
    
          <h2>What are Cookies?</h2>
          <p>
            SR HR (also referred to as "we," "us," or "our") uses cookies on the SR HR Platforms. 
            A cookie is a small text file that contains data, often including a unique anonymous identifier. 
            Cookies are created when your browser loads our website. When this happens, our website sends 
            information to your browser, which then creates a text file. Each time you return to our website, 
            your browser retrieves and sends this file to our website's server.
          </p>
    
          <h2>Types of Technologies We Use</h2>
          <h3>Cookies</h3>
          <p>We use different types of cookies to run our websites and applications. These include:</p>
    
          <h4>Essential Cookies</h4>
          <ul>
            <li>Required for the operation of our platforms</li>
            <li>Enable basic functions like page navigation and access to secure areas</li>
            <li>The website cannot function properly without these cookies</li>
          </ul>
    
          <h4>Analytics Cookies</h4>
          <ul>
            <li>Help us understand how visitors interact with our platforms</li>
            <li>Provide information about visitor numbers, pages visited, and traffic sources</li>
            <li>All information these cookies collect is aggregated and anonymous</li>
          </ul>
    
          <h4>Functional Cookies</h4>
          <ul>
            <li>Allow our platforms to remember choices you make</li>
            <li>Provide enhanced, more personal features</li>
            <li>Can be used to remember changes you have made to text size, fonts, and other customizable parts of web pages</li>
          </ul>
    
          <h4>Targeting/Advertising Cookies</h4>
          <ul>
            <li>Used to deliver content more relevant to you and your interests</li>
            <li>May be used to limit the number of times you see an advertisement</li>
            <li>Help measure the effectiveness of advertising campaigns</li>
          </ul>
    
          <h3>Web Beacons</h3>
          <p>
            We may employ software technology called clear gifs (also known as Web Beacons or web bugs). 
            These are tiny graphics with a unique identifier that help us better manage content by informing 
            us what content is effective. Web beacons are embedded invisibly on our platforms and are about 
            the size of a period at the end of a sentence.
          </p>
    
          <h3>Local Storage</h3>
          <p>
            We may use Local Storage (including HTML5 Local Storage) to store content information and preferences. 
            Third parties with whom we partner to provide certain features on our platforms or to display 
            advertising based upon your web browsing activity may also use HTML5 Local Storage to collect 
            and store information.
          </p>
    
          <h2>Cookie Lifespan</h2>
          <h3>Session Cookies</h3>
          <ul>
            <li>Temporary cookies that expire when you close your browser</li>
            <li>Help us track your movements from page to page so you don't have to provide the same information repeatedly</li>
          </ul>
    
          <h3>Persistent Cookies</h3>
          <ul>
            <li>Remain on your device between browser sessions</li>
            <li>Allow us to remember your preferences and actions</li>
            <li>Have varying durations (expiry dates)</li>
            <li>Can be deleted by you at any time through your browser settings</li>
          </ul>
    
          <h3>Third-Party Cookies</h3>
          <p>
            Some cookies are placed by third-party services that appear on our pages. 
            We use third-party cookies for:
          </p>
          <ul>
            <li>Analytics and performance monitoring</li>
            <li>User behavior tracking</li>
            <li>Advertising and marketing</li>
            <li>Social media integration</li>
          </ul>
          <p>
            These third parties may have access to information about your use of the SR HR Platforms. 
            We recommend reviewing the privacy and cookie policies of these third parties to understand how they use your information.
          </p>
    
          <h2>Your Cookie Choices</h2>
          <p>You have several options to control or limit how we and our partners use cookies:</p>
    
          <h3>Browser Controls</h3>
          <p>Most browsers allow you to manage cookie settings. These settings can usually be found in the 'Preferences' or 'Settings' menu of your browser.</p>
    
          <h3>Third-Party Tools</h3>
          <p>You can opt out of third-party advertising networks using their respective opt-out tools.</p>
    
          <h3>Private Browsing</h3>
          <p>Most browsers have a "private" or "incognito" mode that limits data collection and storage.</p>
    
          <h3>Manual Cookie Deletion</h3>
          <p>You can delete cookies manually through your browser settings.</p>
    
          <p>
            Please note that if you choose to block cookies, you may not be able to use all the features of our platforms.
          </p>
    
          <h2>Updates to This Policy</h2>
          <p>
            We may update this Cookie Policy from time to time to reflect changes in our practices or for operational, 
            legal, or regulatory reasons. We encourage you to periodically review this page for the latest 
            information on our cookie practices.
          </p>
    
          <h2>Contact Us</h2>
          <p>
            If you have any questions about our use of cookies or other technologies, please contact us at:
          </p>
          <p>Email: <a href="mailto:info@kelick.io">info@kelick.io</a></p>
    
          <h2>Effective Date</h2>
          <p>This Cookie Policy is effective as of 29 October 2024.</p>
        </div>
        )}
      </div>

      {/* CSS Styles */}
      <style>{`
        .legal-container {
          max-width: 800px;
          margin: auto;
          font-family: Arial, sans-serif;
          padding: 20px;
        }
        .tab-buttons {
          display: flex;
          border-bottom: 2px solid #ddd;
        }
        .tab-buttons button {
          flex: 1;
          padding: 10px;
          border: none;
          background: #f4f4f4;
          cursor: pointer;
          font-size: 16px;
          font-weight: bold;
          transition: 0.3s;
        }
        .tab-buttons button.active {
          background: #02b9b0;
          color: white;
        }
        .tab-buttons button:hover {
          background: #ddd;
        }
        .tab-content {
          padding: 20px;
          background: #fff;
          border: 1px solid #ddd;
          margin-top: 10px;
        }
        .tab-content h1,.tab-content h2{
            font-weight: 900;
        }
        h2 {
          color: #333;
        }
        p {
          color: #555;
          line-height: 1.6;
        }
      `}</style>
    </div>
  );
}
